import axios from 'axios';
import { LanguageObject } from '@/i18n';

interface OversightOrganizationType {
  id?: number;
  name: LanguageObject;
  state: 'active'; // TODO: enum
  scope: {
    children_type?: 'oversight' | 'service_provider' | null;
    children_oversight_org_type?: number | null;
    mutually_exclusive_children?: boolean | null;
  };
}

interface OversightOrganization {
  id?: number;
  name: LanguageObject;
  state: 'active'; // TODO: enum
  oversighttype: Partial<OversightOrganizationType>;
  parent: Partial<OversightOrganization>[];
}

const api = {
  instance: {
    list: async () => {
      const resp = await axios.get<OversightOrganization[]>(
        '/oversightOrganization/list.php'
      );
      return resp.data;
    },

    get: async (id: number) => {
      const resp = await axios.get<OversightOrganization>(
        '/oversightOrganization/get.php',
        {
          params: { id: id },
        }
      );
      return resp.data;
    },

    add: async (oversight: OversightOrganization) => {
      const resp = await axios.post<{ id: number }>(
        '/oversightOrganization/add.php',
        oversight
      );
      return resp.data.id;
    },

    update: async (oversight: Partial<OversightOrganization>) => {
      await axios.post('/oversightOrganization/update.php', oversight);
    },

    remove: async (id: number) => {
      await axios.delete('/oversightOrganization/delete.php', {
        params: { id: id },
      });
    },
  },
  type: {
    list: async () => {
      const resp = await axios.get<OversightOrganizationType[]>(
        '/oversightOrganizationType/list.php'
      );
      return resp.data;
    },

    get: async (id: number) => {
      const resp = await axios.get<OversightOrganizationType>(
        '/oversightOrganizationType/get.php',
        {
          params: { id: id },
        }
      );
      return resp.data;
    },

    add: async (type: OversightOrganizationType) => {
      const resp = await axios.post<{ id: number }>(
        '/oversightOrganizationType/add.php',
        type
      );
      return resp.data.id;
    },

    update: async (type: Partial<OversightOrganizationType>) => {
      await axios.post('/oversightOrganizationType/update.php', type);
    },

    remove: async (id: number) => {
      await axios.delete('/oversightOrganizationType/delete.php', {
        params: { id: id },
      });
    },
  },
};

export default {
  api,
};

export { OversightOrganization, OversightOrganizationType };
